import { useNavigate } from "react-router-dom";
import { motion } from "framer-motion";
import { Navbar } from "@/components/Navbar";
import { Footer } from "@/components/Footer";
import { Reveal } from "@/components/motion";
import { CASES } from "@/data/content";

export default function CaseStudies() {
  const navigate = useNavigate();
  return (
    <main className="bg-[#FDFBF7] min-h-screen">
      <Navbar />
      <section className="pt-40 md:pt-48 pb-16 max-w-[1400px] mx-auto px-6 md:px-10" data-testid="case-studies-page">
        <p className="text-xs uppercase tracking-[0.3em] text-[#C5A059] mb-6">— Case Studies</p>
        <h1 className="font-serif font-light text-5xl md:text-8xl tracking-tight leading-[0.92] max-w-[14ch]">
          Proof, not promises.
        </h1>
      </section>

      <section className="max-w-[1400px] mx-auto px-6 md:px-10 pb-32 space-y-16">
        {CASES.length === 0 && (
          <div data-testid="cases-empty" className="border-t border-[#E8E4D9] pt-16 text-center">
            <p className="text-[11px] uppercase tracking-[0.3em] text-[#C5A059] mb-4">Coming soon</p>
            <p className="font-serif text-3xl md:text-4xl text-[#1A1713]/80 max-w-2xl mx-auto leading-tight">
              Client results and stories are being prepared — this space is
              reserved and will be published shortly.
            </p>
          </div>
        )}
        {CASES.map((c, i) => (
          <Reveal key={c.slug} i={0}>
            <button
              onClick={() => navigate(`/case-studies/${c.slug}`)}
              data-testid={`case-item-${c.slug}`}
              className={`group grid lg:grid-cols-2 gap-10 items-center w-full text-left ${i % 2 ? "lg:[direction:rtl]" : ""}`}
            >
              <div className="relative overflow-hidden aspect-[16/9] [direction:ltr]">
                <motion.img src={c.img} alt={c.title} className="w-full h-full object-cover" whileHover={{ scale: 1.05 }} transition={{ duration: 0.8, ease: [0.76, 0, 0.24, 1] }} />
              </div>
              <div className="[direction:ltr]">
                <p className="text-[10px] uppercase tracking-[0.25em] text-[#C5A059]">{c.tag} · {c.date}</p>
                <h2 className="font-serif text-4xl md:text-5xl mt-3 leading-none tracking-tight">{c.title}</h2>
                <p className="text-base md:text-lg text-[#1A1713]/70 mt-5 leading-relaxed">{c.excerpt}</p>
                <div className="flex gap-10 mt-8 border-t border-[#E8E4D9] pt-6">
                  {c.metrics.map(([n, l]) => (
                    <div key={l}>
                      <div className="font-serif text-3xl text-[#8a6d2f]">{n}</div>
                      <div className="text-[11px] text-[#78716C] uppercase tracking-wide mt-1">{l}</div>
                    </div>
                  ))}
                </div>
              </div>
            </button>
          </Reveal>
        ))}
      </section>
      <Footer />
    </main>
  );
}
